import React from 'react';
import { PREDEFINED_OPP_SECTIONS } from '../../constants/oportunidadesConstants';

const OppSectionsNavigation = ({
  sections,
  activeSectionId,
  answers,
  generatingReport,
  hasReport,
  hasAnySectionComplete,
  onSectionChange,
  onGenerateReport,
}) => {
  const isSectionComplete = (section) =>
    section.questions?.some((q) => (answers[q.id] || '').trim().length > 0);

  const completedCount = sections.filter(isSectionComplete).length;
  const progress = sections.length
    ? Math.round((completedCount / sections.length) * 100)
    : 0;

  const getButtonText = () => {
    if (generatingReport) return 'Generando...';
    if (hasReport) return 'Regenerar mapa';
    if (!hasAnySectionComplete) return 'Completa al menos una sección';
    return 'Generar mapa de oportunidades';
  };

  return (
    <nav style={{ minWidth: 260 }}>
      <ul className="section-list">
        {sections.map((section) => {
          const hasAnswer = isSectionComplete(section);
          const isActive = section.section_id === activeSectionId;
          const isPredefined = PREDEFINED_OPP_SECTIONS.has(section.section_title);

          return (
            <li key={section.section_id}>
              <button
                className={`section-btn ${hasAnswer ? 'complete' : 'incomplete'}`}
                onClick={() => onSectionChange(section.section_id)}
                style={{ fontWeight: isActive ? 'bold' : 'normal' }}
                title={
                  isPredefined
                    ? `${section.section_title} (recomendaciones estratégicas)`
                    : `${section.section_title} (sugerencias IA)`
                }
              >
                <span className="section-status-icon">
                  {hasAnswer ? '✅' : '⭕'}
                </span>
                <span className="section-name">{section.section_title}</span>
                {!isPredefined && (
                  <span
                    className="section-ai-badge"
                    aria-label="Usa IA"
                    title="Este bloque usa inteligencia artificial"
                    style={{
                      marginLeft: 'auto',
                      fontSize: '0.6rem',
                      fontWeight: 600,
                      letterSpacing: '0.04em',
                      padding: '1px 5px',
                      borderRadius: 4,
                      background: 'var(--color-primary, #4f46e5)',
                      color: '#fff',
                      lineHeight: 1.4,
                      flexShrink: 0,
                    }}
                  >
                    IA
                  </span>
                )}
              </button>
            </li>
          );
        })}
      </ul>

      {!hasReport && (
        <div className="progress-indicator">
          <div className="progress-bar-container">
            <div
              className={`progress-bar ${progress === 100 ? 'complete' : progress >= 50 ? 'half' : 'start'}`}
              style={{ width: `${progress}%` }}
            />
          </div>
          <span className="progress-text">
            {completedCount}/{sections.length} secciones completas
          </span>
        </div>
      )}

      <button
        className={`primary-btn ${hasReport ? 'regenerate-mode' : ''}`}
        onClick={onGenerateReport}
        disabled={generatingReport || !hasAnySectionComplete}
        title={
          !hasAnySectionComplete
            ? 'Completa al menos una sección primero'
            : hasReport
              ? 'Regenerar mapa con información actualizada'
              : ''
        }
      >
        {getButtonText()}
      </button>
    </nav>
  );
};

export default OppSectionsNavigation;
